import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
import { governRouter, governRouters } from './modules/govern.js'

import { payCenterRouter, payCenterRouters } from './modules//pay.js'

import { pricingRouter, pricingRouters } from './modules/pricing.js'
import { externalSysRouters } from './modules/external.js'
import { operationRouter, operationRouters } from './modules/operationSystem.js'

import { toolsRoutes, toolsRouter } from './modules/tools.js'

import { workOrderRouter, workOrderRouters } from './modules/workorder.js'

Vue.use(Router)

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
	{
		path: '/redirect',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/redirect/:path*',
				component: () => import('@/views/redirect/index')
			}
		]
	},
	{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/forgetpw',
		name: 'Forgetpassword',
		component: () => import('@/views/forgetpassword/index'),
		hidden: true
	},
	{
		path: '/repassword',
		component: () => import('@/views/repassword/index'),
		hidden: true
	},
	{
		path: '/auth-redirect',
		component: () => import('@/views/login/auth-redirect'),
		hidden: true
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/error-page/404'),
		hidden: true
	},
	{
		path: '/401',
		component: Layout,
		children: [
			{
				path: '/401',
				component: () => import('@/views/error-page/401')
			}
		],
		hidden: true
	},
	{
		path: '/',
		component: Layout,
		redirect: '/home',
		children: [
			{
				path: 'home',
				component: () => import('@/views/home/index'),
				name: 'Home',
				meta: { title: '首页', icon: 'home', affix: true }
			}
		]
	},
	{
		path: '/addCar',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/car/add'),
				name: 'AddCar',
				meta: { title: '添加车辆' }
			}
		]
	},
	{
		path: '/editCar/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/car/add'),
				name: 'EditCar',
				meta: { title: '编辑车辆' }
			}
		]
	},
	{
		path: '/carDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/car/add'),
				name: 'CarDetails',
				meta: { title: '车辆详情' }
			}
		]
	},
	{
		path: '/editDriver/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/driver/edit'),
				name: 'EditDriver',
				meta: { title: '编辑司机' }
			}
		]
	},
	// 出行司机详情
	{
		path: '/travelDriver/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/travel/driver/edit'),
				name: 'TravelDriver',
				meta: { title: '司机详情' }
			}
		]
	},
	// 出行车辆详情
	{
		path: '/travelCar/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/travel/car/add'),
				name: 'TravelCar',
				meta: { title: '车辆详情' }
			}
		]
	},
	{
		path: '/driverDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/driver/edit'),
				name: 'DriverDetails',
				meta: { title: '司机详情' }
			}
		]
	},
	// 招募审核工作台详情
	{
		path: '/examineDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/examine/detaile'),
				name: 'ExamineDetails',
				meta: { title: '司机详情', module: 'examine' }
			}
		]
	},
	{
		path: '/examineEdit/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/examine/detaile'),
				name: 'editDriver',
				meta: { title: '编辑司机', module: 'examine' }
			}
		]
	},
	{
		path: '/reviewexa/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/examine/review'),
				name: 'review',
				meta: { title: '审核详情', module: 'examine' }
			}
		]
	},
	{
		path: '/reviewch/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/task/changecar/review'),
				name: 'reviewch',
				meta: { title: '审核', module: 'changecar' }
			}
		]
	},
	{
		path: '/reviewe/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/task/changecar/review'),
				name: 'review',
				meta: { title: '审核详情', module: 'changecar' }
			}
		]
	},
	{
		path: '/reviewhg/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/material/review'),
				name: 'reviewhg',
				meta: { title: '审核' }
			}
		]
	},
	{
		path: '/license_verify/details/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/license-verify/details'),
				name: 'verify_details',
				meta: { title: '查看' }
			}
		]
	},
	{
		path: '/materDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/material/edit'),
				name: 'materDetail',
				meta: { title: '审核详情' }
			}
		]
	},
	{
		path: '/applyChangeCar',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/applyChangeCar/:id/:city_id',
				component: () => import('@/views/transport/driver/applyChangeCar'),
				name: 'ApplyChangeCar',
				meta: { title: '申请换车' }
			}
		]
	},
	{
		path: '/infoChange',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/infoChange/:id',
				component: () => import('@/views/transport/driver/infoChange'),
				name: 'InfoChange',
				meta: { title: '申请信息变更' }
			}
		]
	},
	{
		path: '/handle',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/handle/:id/:type',
				component: () => import('@/views/task/changeinfo/handle'),
				name: 'InfoHandle',
				meta: { title: '信息变更' }
			}
		]
	},
	{
		path: '/review',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/review/:id/:noteId?',
				component: () => import('@/views/transport/driver/review'),
				name: 'Review',
				meta: { title: '审核' }
			}
		]
	},
	{
		path: '/cars/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/car/detail'),
				name: 'CarDetail',
				meta: { title: '车辆详情', activeMenu: '/cars' }
			}
		]
	},
	{
		path: '/driver/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/driver/detail'),
				name: 'DriverDetail',
				meta: { title: '司机详情', activeMenu: '/admin/v1/drivers' }
			}
		]
	},
	{
		path: '/driverDetailNew/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/driver-detail/index'),
				name: 'DriverDetailNew',
				meta: { title: '司机详情' }
			}
		]
	},
	{
		path: '/driverDetailNew/r_l',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/driver-detail/index'),
				name: 'DriverDetailNewRL',
				meta: { title: '司机详情' }
			}
		]
	},
	{
		path: '/view/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/view/detail',
				component: () => import('@/views/datalook/detail'),
				name: 'Detail',
				meta: { title: '详情', activeMenu: '/view' }
			}
		]
	},
	{
		path: '/workorder/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				// props: true,
				component: () => import('@/views/work-order/accept-order/index.vue'),
				name: 'WorkOrderDetail',
				props: true,
				meta: { title: '工单详情', activeMenu: '/WorkOrderDetail' }
			}
		]
	},
	{
		path: '/workOrder_detail/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/work-order/accept-order/index.vue'),
				name: 'WorkOrderDetail',
				props: true,
				meta: { title: '工单详情', activeMenu: '/WorkOrderDetail' }
			}
		]
	},
	{
		path: '/order/workorder/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order/workorder/detail'),
				name: 'WorkOrderDetailId',
				meta: { title: '工单详情', activeMenu: '/workorder' }
			}
		]
	},
	{
		path: '/workorder/invoice/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order/workorder/carInvoice'),
				name: 'CarInvoice',
				meta: { title: '车内录音', activeMenu: '/workorder' }
			}
		]
	},
	{
		path: '/real_order_cancel_fee_detail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order-center/real_order/detail/cancel_fee_detail'),
				name: 'CancelFeeDetail',
				meta: { title: '取消费详情', activeMenu: '/CancelFeeDetail' }
			}
		]
	},
	{
		path: '/real_order_fee_detail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order-center/real_order/detail/fee_detail'),
				name: 'FeeDetail',
				meta: { title: '计费详情', activeMenu: '/FeeDetail' }
			}
		]
	},
	//订单详情
	{
		path: '/order_detail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order-center/real_order/detail/order_detail'),
				name: 'OrderDetail',
				meta: { title: '订单详情', activeMenu: '/OrderDetail' }
			}
		]
	},
	{
		path: '/orderDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/travel-ststay/orderDetail'),
				name: 'OrderDetailTravel',
				meta: { title: '订单详情', activeMenu: '/OrderDetailTravel' }
			}
		]
	},
	{
		path: '/workorder/invoice-con/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order/workorder/conInvoice'),
				name: 'ConInvoice',
				meta: { title: '通话录音', activeMenu: '/workorder' }
			}
		]
	},
	// 受理工单
	{
		path: '/workorder/accept/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				// props: true,
				component: () => import('@/views/work-order/accept-order/index.vue'),
				name: 'WorkOrderAccept',
				props: true,
				meta: { title: '受理工单', activeMenu: '/WorkOrderList' }
			}
		]
	},
	{
		path: '/travelworkorder/accept/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				// props: true,
				component: () => import('@/views/travel-work-order/accept-order/index.vue'),
				name: 'TravelWorkOrder',
				props: true,
				meta: { title: '受理工单', activeMenu: '/TravelWorkOrder' }
			}
		]
	},
	{
		path: '/notOrder/accept/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				// props: true,
				component: () => import('@/views/work-order/not_order_id_accept/index.vue'),
				name: 'WorkOrderNotAccept',
				props: true,
				meta: { title: '内部流转工单受理', activeMenu: '/WorkOrderList' }
			}
		]
	},
	{
		path: '/notOrder/accept/look/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				// props: true,
				component: () => import('@/views/work-order/not_order_id_accept/index.vue'),
				name: 'WorkOrderNotAcceptLook',
				props: true,
				meta: { title: '内部流转工单受理', activeMenu: '/WorkOrderList' }
			}
		]
	},
	{
		path: '/notOrder_workOrder_detail/:id',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/work-order/not_order_id_accept/index.vue'),
				name: 'WorkOrderNotAcceptLook',
				props: true,
				meta: { title: '内部流转工单受理', activeMenu: '/WorkOrderList' }
			}
		]
	},
	{
		path: '/invoices',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/index'),
				name: 'InvoiceList',
				meta: { title: '发票管理', activeMenu: '/invoice' }
			}
		]
	},
	{
		path: '/invoices/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/detail'),
				name: 'InvoiceDetail',
				meta: { title: '发票详情', activeMenu: '/invoice/detail' }
			}
		]
	},
	{
		path: '/pickBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/pickBind'),
				name: 'pickBind',
				meta: { title: '绑定偏好围栏', activeMenu: '/fence/pickBind' }
			}
		]
	},
	{
		path: '/limitBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/limitBind'),
				name: 'limitBind',
				meta: { title: '绑定限单围栏', activeMenu: '/fence/limitBind' }
			}
		]
	},
	{
		path: '/virtualBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/virtualBind'),
				name: 'virtualBind',
				meta: { title: '绑定预约虚拟接单围栏', activeMenu: '/fence/virtualBind' }
			}
		]
	},
	{
		path: '/correctionBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/correctionBind'),
				name: 'correctionBind',
				meta: { title: '绑定纠偏围栏', activeMenu: '/fence/correctionBind' }
			}
		]
	},
	{
		path: '/forbidBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/forbidBind'),
				name: 'forbidBind',
				meta: { title: '绑定禁单围栏', activeMenu: '/fence/forbidBind' }
			}
		]
	},
	{
		path: '/regeo',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/regeoFence'),
				name: 'regeo',
				meta: { title: '逆地理围栏', activeMenu: '/fence/regeo' }
			}
		]
	},
	{
		path: '/forbidDispatchBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/forbidDispatchBind'),
				name: 'forbidDispatchBind',
				meta: {
					title: '绑定不派单围栏',
					activeMenu: '/fence/forbidDispatchBind'
				}
			}
		]
	},
	{
		path: '/forbidEstimateBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/forbidEstimateBind'),
				name: 'forbidEstimateBind',
				meta: {
					title: '绑定不报价围栏',
					activeMenu: '/fence/forbidEstimateBind'
				}
			}
		]
	},
	{
		path: '/forbidFinishBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/forbidFinishBind'),
				name: 'forbidFinishBind',
				meta: { title: '绑定不结束围栏', activeMenu: '/fence/forbidFinishBind' }
			}
		]
	},
	{
		path: '/EstimateBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/estimateBind'),
				name: 'estimateBind',
				meta: { title: '报价围栏', activeMenu: '/fence/estimateBind' }
			}
		]
	},
	{
		path: '/incomeFloorBind',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/incomeFloorBind'),
				name: 'incomeFloorBind',
				meta: { title: '绑定即时保底围栏', activeMenu: '/fence/incomeFloorBind' }
			}
		]
	},
	{
		path: '/geoTool',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/geoTool'),
				name: 'geoTool',
				meta: { title: '导入基础围栏', activeMenu: '/fence/geoTool' }
			}
		]
	},
	{
		path: '/reassigns',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/order/reassign/index'),
				name: 'ReassignConfig',
				meta: { title: '免责改派配置', activeMenu: '/reassign' }
			}
		]
	},
	{
		path: '/points',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/transport/driver/archive_points'),
				name: 'ArchivePoints',
				meta: { title: '司机大盘', activeMenu: '/point' }
			}
		]
	},
	{
		path: '/labor',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/labor/index'),
				name: 'LaborManage',
				meta: { title: '劳务公司管理', activeMenu: '/labor' }
			}
		]
	},
	{
		path: '/accountDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/account/accountDetail'),
				name: 'AccountDetailManage',
				meta: { title: '流水详情' }
			}
		]
	},
	{
		path: '/accountAllDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/account/accountAllDetail'),
				name: 'AccountAllDetailManage',
				meta: { title: '流水详情' }
			}
		]
	},
	{
		path: '/platform/stats',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/platform/stats'),
				name: 'PlatformStats',
				meta: { title: '平台统计' }
			}
		]
	},
	{
		path: '/company',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/company/info/:no/:id',
				component: () => import('@/views/company/edit'),
				name: 'CompanyEdit',
				meta: { title: '详情' }
			},
			{
				path: '/company/audit/:no/:id',
				component: () => import('@/views/company/edit'),
				name: 'CompanyAudit',
				meta: { title: '审核运力公司' }
			},
			{
				path: '/company/edit/:no/:id',
				component: () => import('@/views/company/edit'),
				name: 'CompanyDetail',
				meta: { title: '编辑运力公司' }
			},
			{
				path: '/company/add',
				component: () => import('@/views/company/edit'),
				name: 'CompanyAdd',
				meta: { title: '添加运力公司' }
			}
		]
	},
	{
		path: '/manage',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/manage/detile/:id',
				component: () => import('@/views/groupchat/manage/detile'),
				name: 'ManageDetile',
				meta: { title: '详情' }
			}
		]
	},
	{
		path: '/check/taskList',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/check/taskList'),
				name: 'BillCheckTaskList',
				meta: { title: '对账任务管理', activeMenu: '/check/taskList' }
			}
		]
	},
	{
		path: '/check/summaryList',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/check/summaryList'),
				name: 'BillCheckSummaryList',
				meta: { title: '对账结果管理', activeMenu: '/check/summaryList' }
			}
		]
	},
	// 质检详情
	{
		path: '/quality/detail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/quality/appeal/index'),
				name: 'QualityDetail',
				meta: { title: '质检详情', activeMenu: '/quality/detail' }
			}
		]
	},

	{
		path: '/check/uploadList/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/check/uploadList'),
				name: 'BillCheckUploadList',
				meta: { title: '上传管理', activeMenu: '/check/uploadList' }
			}
		]
	},
	{
		path: '/check/editUploadRelation/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/check/editUploadRelation'),
				name: 'EditUploadRelation',
				meta: { title: '编辑映射关系', activeMenu: '/check/editUploadRelation' }
			}
		]
	},
	{
		path: '/compont/default_edit/:num',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cash/compont/default_edit'),
				name: 'defaultEdit',
				meta: { title: '默认编辑' }
			}
		]
	},
	{
		path: '/compont/default_readonly/:num',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cash/compont/default_readonly'),
				name: 'defaultReadonly',
				meta: { title: '默认-查看详情' }
			}
		]
	},
	{
		path: '/compont/special_edit/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cash/compont/special_edit'),
				name: 'specialEdit',
				meta: { title: '特殊编辑' }
			}
		]
	},
	{
		path: '/compont/special_readonly/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cash/compont/special_readonly'),
				name: 'specialReadonly',
				meta: { title: '特殊-查看详情' }
			}
		]
	},
	{
		path: '/compont/addSpecial',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cash/compont/addSpecial'),
				name: 'addSpecial',
				meta: { title: '新增特殊设置' }
			}
		]
	},
	{
		path: '/agentRule',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/agentRule/info/:id',
				component: () => import('@/views/pay-center/ledger/agentRuleForm'),
				name: 'AgentRuleForm',
				meta: { title: '获客渠道规则详情' }
			},
			{
				path: '/agentRule/edit/:id',
				component: () => import('@/views/pay-center/ledger/agentRuleForm'),
				name: 'AgentRuleEdit',
				meta: { title: '编辑获客渠道规则' }
			},
			{
				path: '/agentRule/add',
				component: () => import('@/views/pay-center/ledger/agentRuleForm'),
				name: 'AgentRuleAdd',
				meta: { title: '新增获客渠道规则' }
			}
		]
	},
	{
		path: '/rent/freezePlanList/:planNO',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/rent-freeze-plan/planList'),
				name: 'FreezePlanListManage',
				meta: { title: '冻结计划管理' }
			}
		]
	},
	{
		path: '/rent/unfreezeRecordList/:planNO',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/rent-freeze-plan/unfreezeRecord'),
				name: 'UnfreezeRecordListManage',
				meta: { title: '解冻记录' }
			}
		]
	},
	{
		path: '/company/freezePlanList/:planNO',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/rent-freeze-plan/planList'),
				name: 'CompanyFreezePlanListManage',
				meta: { title: '运力公司冻结计划管理' }
			}
		]
	},
	{
		path: '/company/unfreezeRecordList/:planNO',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/rent-freeze-plan/unfreezeRecord'),
				name: 'CompanyUnfreezeRecordListManage',
				meta: { title: '运力公司解冻记录' }
			}
		]
	},
	{
		path: '/cooperationchannels/add/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/cooperation-channels/components/add'),
				name: 'CooperationChannelsAdd',
				meta: { title: '合作渠道管理', activeMenu: '/cooperationchannels/add' }
			}
		]
	},
	{
		path: '/invoice/getCompany/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/company/getCompany'),
				name: 'InvoiceGetCompany',
				meta: { title: '查看公司主体', activeMenu: '/invoice/getCompany' }
			}
		]
	},
	{
		path: '/invoice/editCompany/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/company/editCompany'),
				name: 'InvoiceEditCompany',
				meta: { title: '编辑公司主体', activeMenu: '/invoice/editCompany' }
			}
		]
	},
	{
		path: '/invoice/getAgentRouter/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/agentRouter/getAgentRouter'),
				name: 'GetAgentRouter',
				meta: { title: '查看渠道主体', activeMenu: '/invoice/getAgentRouter' }
			}
		]
	},
	{
		path: '/invoice/editAgentRouter/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/agentRouter/editAgentRouter'),
				name: 'EditAgentRouter',
				meta: { title: '编辑渠道主体', activeMenu: '/invoice/editAgentRouter' }
			}
		]
	},
	{
		path: '/invoice/getCityRouter/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/cityRouter/getCityRouter'),
				name: 'GetCityRouter',
				meta: { title: '查看城市主体', activeMenu: '/invoice/getCityRouter' }
			}
		]
	},
	{
		path: '/invoice/editCityRouter/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/cityRouter/editCityRouter'),
				name: 'EditCityRouter',
				meta: { title: '编辑城市主体', activeMenu: '/invoice/editCityRouter' }
			}
		]
	},
	{
		path: '/invoice/addCityRouter/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/cityRouter/addCityRouter'),
				name: 'AddCityRouter',
				meta: { title: '新增城市主体', activeMenu: '/invoice/addCityRouter' }
			}
		]
	},
	{
		path: '/companys/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/company/companyList'),
				name: 'InvoiceEditCompany',
				meta: { title: '开票主体管理' }
			}
		]
	},
	{
		path: '/routers/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/agentRouter/agentList'),
				name: 'InvoiceRouter',
				meta: { title: '渠道开票管理' }
			}
		]
	},
	{
		path: '/citys/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/invoice/cityRouter/cityList'),
				name: 'InvoiceCity',
				meta: { title: '城市开票管理' }
			}
		]
	},
	// 运营-活动管理，冲单编辑，查看详情
	{
		path: '/single_activity',
		component: Layout,
		props: true,
		hidden: true,
		children: [
			{
				path: '/single_activity/editor',
				name: 'SingleActivityEditor',
				component: () =>
					import('@/views/operating/activity_management/single_activity/editor/index.vue'),
				meta: { title: '冲单活动编辑' }
			},
			{
				path: '/single_activity/editor/:id',
				name: 'SingleActivityEditorUpdate',
				component: () =>
					import('@/views/operating/activity_management/single_activity/editor/index.vue'),
				meta: { title: '冲单活动更新' }
			},
			{
				path: '/single_activity/editor/copy/:id',
				name: 'SingleActivityEditorUpdateCopy',
				component: () =>
					import('@/views/operating/activity_management/single_activity/editor/index.vue'),
				meta: { title: '冲单活动快速创建' }
			},
			{
				path: '/single_activity/check_details/:id',
				name: 'SingleActivityCheckDetails',
				component: () =>
					import('@/views/operating/activity_management/single_activity/check_details/index.vue'),
				meta: { title: '冲单活动详情' }
			},
			{
				path: '/single_activity/driver_upload/:id',
				name: 'SingleActivityDriverUpload',
				component: () =>
					import('@/views/operating/activity_management/single_activity/driver_upload/index.vue'),
				meta: { title: '上传司机名单' }
			}
		]
	},

	{
		path: '/settle/settleDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/settle/settleDetail'),
				name: 'SettleDetail',
				meta: { title: '查看收款订单明细', activeMenu: '/settle/settleDetail' }
			}
		]
	},
	{
		path: '/advanceTaskInfo/:id/:timestamp',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/advance_risk_task/taskInfo'),
				name: 'AdvanceTaskInfoManage',
				meta: { title: '风控垫付任务详情' }
			}
		]
	},
	{
		path: '/driver_background/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/driver-background/set/detail'),
				name: 'DriverBackground',
				meta: { title: '司机背调配置' }
			}
		]
	},
	{
		path: '/advanceByRuleList/:rule_no',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/pay-center/white-rule/advanceOrderList'),
				name: 'AdvanceOrderListByRule',
				meta: { title: '垫付流水详情' }
			}
		]
	},
	{
		path: '/trainEdit/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/driver-train/manage/edit'),
				name: 'trainedit',
				meta: { title: '培训编辑' }
			}
		]
	},
	{
		path: '/trainDetail/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/driver-train/manage/detail'),
				name: 'trainDetail',
				meta: { title: '培训查看' }
			}
		]
	},
	{
		path: '/driver-train/train_review',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/driver-train/train_review/add',
				component: () => import('@/views/driver-train/manage/components/DriverTrainEdit'),
				name: 'trainReviewAdd',
				meta: { title: '培训创建' }
			},
			{
				path: '/driver-train/train_review/edit/:id',
				component: () => import('@/views/driver-train/manage/components/DriverTrainEdit'),
				name: 'trainReviewEdit',
				meta: { title: '培训编辑' }
			},
			{
				path: '/driver-train/train_review/review/:id',
				component: () => import('@/views/driver-train/manage/components/DriverTrainEdit'),
				name: 'trainReviewReview',
				meta: { title: '培训查看' }
			}
		]
	},
	{
		path: '/driver-train/course-manage',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/driver-train/course-manage/create',
				component: () => import('@/views//driver-train/course-manage/create'),
				name: 'courseCreate',
				meta: { title: '课程创建' }
			},
			{
				path: '/driver-train/course-manage/edit',
				component: () => import('@/views//driver-train/course-manage/edit'),
				name: 'courseEdit',
				meta: { title: '课程编辑' }
			},
			{
				path: '/driver-train/course-manage/detail',
				component: () => import('@/views//driver-train/course-manage/detail'),
				name: 'courseDetail',
				meta: { title: '课程详情' }
			}
		]
	},
	{
		path: '/package/packageBatchList',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/coupon-system/gift-manage/package-batch-list'),
				name: 'packageBatchList',
				meta: { title: '礼包提取列表' }
			}
		]
	},
	// 一线工作台--容联业务
	{
		path: '/one_line_table',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/one_line_table_new',
				component: () => import('@/views/one-table-line/new/index'),
				name: 'OneLineTableNew',
				meta: { title: '智能辅助平台' }
			},
			{
				path: '/one_line_table',
				component: () => import('@/views/one-table-line/index'),
				name: 'OneLineTable'
			}
		]
	},
	{
		path: '/subcontract/white-list/batch-record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/dispatch-system/subcontract/white-list/batch-record'),
				name: 'subcontractBatchRecord',
				meta: { title: '批量操作记录' }
			}
		]
	},
	{
		path: '/start-hive-editmap',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/realtime-account/artificial-set/edit-map'),
				name: 'startHiveEditMap'
			}
		]
	},
	{
		path: '/start-hive-editall',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/realtime-account/artificial-set/edit-all'),
				name: 'startHiveEditAll',
				meta: { title: '调整库存（全城）' }
			}
		]
	},
	{
		path: '/default-set/log/:id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/realtime-account/default-set/log'),
				name: 'defaultSetLog',
				meta: { title: '查看日志' }
			}
		]
	},
	{
		path: '/order-mileagestock/log',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/realtime-account/order-mileagestock/log'),
				name: 'orderMileagestockLog',
				meta: { title: '查看日志' }
			}
		]
	},
	{
		path: '/minute-conf/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/to-real/minute-conf/edit'),
				name: 'minuteConfEdit',
				meta: { title: '转即时分钟配置' }
			}
		]
	},
	// 营销系统
	{
		path: '/marketing',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/marketing/coupon_system/coupon_statistical/:id',
				component: () =>
					import('@/views/coupon-system/coupon-manage/components/coupon-statistical'),
				name: 'couponSystemCouponStatistiacl',
				meta: { title: '优惠券统计' }
			}
		]
	},
	{
		path: '/charge-back',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/to-real/charge-back/edit',
				component: () => import('@/views/to-real/charge-back/edit'),
				name: 'toRealChargeBackEdit',
				meta: { title: '退单时间配置' }
			}
		]
	},
	{
		path: '/order-reassignment-fee',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-reassignment-fee',
				component: () => import('@/views/order-reassignment-fee/components/add.vue'),
				name: 'reassignmentAdd',
				meta: { title: '配置改派费' }
			}
		]
	},
	{
		path: '/order-price-dispatch',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-price-dispatch',
				component: () => import('@/views/order-price-dispatch/price-Issuing-ranges/components/add'),
				name: 'IssuingAdd',
				meta: { title: '配置一口价发单范围' }
			}
		]
	},
	{
		path: '/order-price-dispatch/price-immediate-issuing',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-price-dispatch/price-immediate-issuing',
				component: () =>
					import('@/views/order-price-dispatch/price-immediate-issuing/components/add'),
				name: 'immediateIssuingAdd',
				meta: { title: '配置一口价转即时发单范围' }
			}
		]
	},
	{
		path: '/order-dispatch/Issuing-ranges',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-dispatch/Issuing-ranges',
				component: () => import('@/views/order-dispatch/Issuing-ranges/components/add'),
				name: 'IssuingRangesComponentsAdd',
				meta: { title: '配置实时计价发单范围' }
			}
		]
	},
	{
		path: '/order-dispatch/immediate-issuing',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-dispatch/immediate-issuing',
				component: () => import('@/views/order-dispatch/immediate-issuing/components/add'),
				name: 'immediateIssuingComponentsAdd',
				meta: { title: '配置实时计价转即时发单范围' }
			}
		]
	},
	{
		path: '/order-dispatch/Issuing-mode',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-dispatch/Issuing-mode',
				component: () => import('@/views/order-dispatch/Issuing-mode/components/add'),
				name: 'IssuingmodeComponentsAdd',
				meta: { title: '配置实时计价发单模式(0-24H)' }
			}
		]
	},
	{
		path: '/order-dispatch/Issuing-mode-puls',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-dispatch/Issuing-mode-puls',
				component: () => import('@/views/order-dispatch/Issuing-mode-puls/components/add'),
				name: 'IssuingmodepulsAdd',
				meta: { title: '配置实时计价发单模式(24H以上)' }
			}
		]
	},
	{
		path: '/order-dispatch/Issuance-round-time',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-dispatch/Issuance-round-time',
				component: () => import('@/views/order-dispatch/Issuance-round-time/components/add'),
				name: 'IssuingroundtimeAdd',
				meta: { title: '配置发单司机活跃时间' }
			}
		]
	},
	{
		path: '/order-book-cancel/components-add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-book-cancel/components-add',
				component: () => import('@/views/order-book-cancel/components/add'),
				name: 'orderBookCancelAdd',
				meta: { title: '配置一口价取消补偿费' }
			}
		]
	},
	{
		path: '/create-work-order',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/create-work-order/add',
				component: () => import('@/views/work-order/create-work-order/index'),
				name: 'CreateWorkOrder',
				meta: { title: '新建工单' }
			}
		]
	},
	{
		path: '/create-batch-work-order',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/create-batch-work-order/add',
				component: () => import('@/views/work-order/create-batch-work-order/index'),
				name: 'CreateBatchWorkOrder',
				meta: { title: '批量新建工单' }
			}
		]
	},
	{
		path: '/ensure-activity/driver-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/driver-list',
				component: () => import('@/views/operating/ensure-activity/driver-list'),
				name: 'EnsureActivityDriverList',
				meta: { title: '活动司机列表' }
			}
		]
	},
	{
		path: '/ensure-activity/order-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/order-list',
				component: () => import('@/views/operating/ensure-activity/order-list.vue'),
				name: 'EnsureActivityOrderList',
				meta: { title: '保底订单查询' }
			}
		]
	},
	{
		path: '/ensure-activity/activity-template-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/activity-template-list',
				component: () =>
					import('@/views/operating/ensure-activity/activity-template-list/index.vue'),
				name: 'EnsureActivityTemplateList',
				meta: { title: '活动模板列表' }
			}
		]
	},
	{
		path: '/ensure-activity/promotion-degradation-configuration',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/promotion-degradation-configuration',
				component: () =>
					import('@/views/operating/ensure-activity/promotion-degradation-configuration/index.vue'),
				name: 'EnsureActivityPromotionDegradationConfiguration',
				meta: { title: '考核升降级配置' }
			}
		]
	},
	{
		path: '/ensure-activity/elimination-replacement-configuration',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/elimination-replacement-configuration',
				component: () =>
					import('@/views/operating/ensure-activity/elimination-replacement-configuration/index.vue'),
				name: 'EnsureActivityEliminationReplacementConfiguration',
				meta: { title: '淘汰规则配置' }
			}
		]
	},
	{
		path: '/ensure-activity/shift-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/shift-list',
				component: () => import('@/views/operating/ensure-activity/shift-list'),
				name: 'EnsureActivityShiftList',
				meta: { title: '班次变更申请记录' }
			},
			{
				path: '/ensure-activity/shift-detail',
				component: () => import('@/views/operating/ensure-activity/shift-detail'),
				name: 'EnsureActivityShiftDetail',
				meta: { title: '保底班次详情' }
			}
		]
	},
	{
		path: '/ensure-activity/black_driver_list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/black_driver_list',
				component: () => import('@/views/dispatch-system/subcontract/blacklist'),
				name: 'EnsureActivityBlackDriverList',
				meta: { title: '保底活动黑名单' }
			}
		]
	},
	{
		path: '/company',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/company/margin_fleet/:id',
				component: () => import('@/views/company/margin_fleet.vue'),
				name: 'CompanyMarginFleet',
				meta: { title: '车队保证金' }
			},
			{
				path: '/company/margin_fleet/add/:id',
				component: () => import('@/views/company/margin_fleet.vue'),
				name: 'CompanyMarginFleet',
				meta: { title: '新增车队保证金' }
			}
		]
	},
	{
		path: '/capture-the-price/components-detail',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/capture-the-price/components-detail',
				component: () => import('@/views/capture-the-price/components/detail'),
				name: 'CapturePriceManageDetail',
				meta: { title: '抓价管理详情' }
			}
		]
	},
	{
		path: '/order-appointment-warn/components-add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order-appointment-warn/components-add',
				component: () => import('@/views/order-warn/order_appointment_warn/components/add'),
				name: 'OrderAppointmentWarnAdd',
				meta: { title: '配置预约实时计价预警' }
			}
		]
	},
	{
		path: '/experimental-price/components-detail',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/experimental-price/components-detail',
				component: () => import('@/views/experimental-price/components/detail'),
				name: 'ExperimentalPriceManageDetail',
				meta: { title: '实验价格管理' }
			}
		]
	},
	{
		path: '/order_book_warn/components-add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/order_book_warn/components-add',
				component: () => import('@/views/order-warn/order_book_warn/components/add'),
				name: 'OrderBookWarnAdd',
				meta: { title: '配置预约一口价预警' }
			}
		]
	},

	{
		path: '/applets/seckill/activity_record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/applets/seckill/activity_record',
				component: () => import('@/views/coupon-system/applets-seckill/activity-record'),
				name: 'ActivityRecord',
				meta: { title: '活动参与详情' }
			}
		]
	},
	/*
	 * 标签管理
	 * */
	{
		path: '/basic_configuration/label',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/basic_configuration/label/operation_log',
				component: () => import('@/views/base-set/label/operation_log'),
				name: 'LabelOperationLog',
				meta: { title: '操作日志' }
			}
		]
	},
	{
		path: '/work-order-record/record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/work-order-record/record',
				component: () => import('@/views/work-order/work-order-record'),
				name: 'WorkOrderRecord',
				meta: { title: '工单记录' }
			}
		]
	},
	{
		path: '/task',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/task/driver_detail/:id',
				component: () => import('@/views/transport_components/check_detail_components/index'),
				name: 'CheckDetailComponents',
				meta: { title: '详情' }
			}
		]
	},
	{
		path: '/task',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/task/info_change_quality/:id',
				component: () =>
					import('@/views/task/quality_workbench/info_change_workbench/quality_index'),
				name: 'InfoChangeQuality',
				meta: { title: '详情' }
			}
		]
	},
	{
		path: '/task',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/task/car/quality_transfer/:id',
				component: () => import('@/views/task/quality_workbench/transfer_workbench/review'),
				name: 'QualityTransfer',
				meta: { title: '详情' }
			}
		]
	},
	{
		path: '/ensure-activity/biz-verify-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/ensure-activity/biz-verify-list',
				component: () => import('@/views/operating/ensure-activity/biz-verify'),
				name: 'BizVerifyList',
				meta: { title: '开城配置' }
			}
		]
	},
	{
		path: '/basic_set',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/basic_set/advanced_approve/edit',
				component: () => import('@/views/base-set/advaced_approve/edit'),
				name: 'AdvancedApproveEdit',
				meta: { title: '配置详情' }
			}
		]
	},
	{
		path: '/admin/v1/activity_norm/activity_log',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/admin/v1/activity_norm/activity_log',
				component: () => import('@/views/coupon-system/activity-norm/activity-log'),
				name: 'ActivityNormLog',
				meta: { title: '活动参与记录' }
			}
		]
	},
	{
		path: '/coupon-system/coupon-give/log',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/coupon-system/coupon-give/log',
				component: () => import('@/views/coupon-system/coupon-give/log'),
				name: 'CouponGiveLog',
				meta: { title: '发券操作日志' }
			}
		]
	},
	{
		path: '/admin/v1/ensure_sprint/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/admin/v1/ensure_sprint/edit',
				component: () => import('@/views/operating/ensure-sprint/edit'),
				name: 'EnsureSprintEdit',
				meta: { title: '保底冲单活动' }
			}
		]
	},
	{
		path: '/third_charge_model/simulated_price',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/third_charge_model/simulated_price',
				component: () => import('@/views/experimental-price/simulated-price'),
				name: 'simulated_price',
				meta: { title: '多模版比价' }
			}
		]
	},
	{
		path: '/rentAgreement',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/rentAgreement/info/:trade_no',
				component: () => import('@/views/pay-center/rent-agreement/agreementForm'),
				name: 'AgreementForm',
				meta: { title: '扣租协议详情' }
			},
			{
				path: '/rentAgreement/edit/:trade_no',
				component: () => import('@/views/pay-center/rent-agreement/agreementForm'),
				name: 'AgreementEdit',
				meta: { title: '编辑扣租协议' }
			},
			{
				path: '/rentAgreement/add',
				component: () => import('@/views/pay-center/rent-agreement/agreementForm'),
				name: 'AgreementAdd',
				meta: { title: '新增扣租协议' }
			}
		]
	},
	{
		path: '/rentAccountDetailList',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/rentAccountDetailList/:plan_no',
				component: () => import('@/views/pay-center/rent-account-detail/rentAccountDetailList'),
				name: 'RentAccountDetailList',
				meta: { title: '入账及划转记录' }
			}
		]
	},
	{
		path: '/rentAgreementByCompany',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/rentAgreementByCompany/info/:trade_no',
				component: () => import('@/views/pay-center/rent-agreement/agreementFormByCompany'),
				name: 'AgreementFormByCompany',
				meta: { title: '租赁公司扣租协议详情' }
			},
			{
				path: '/rentAgreementByCompany/edit/:trade_no',
				component: () => import('@/views/pay-center/rent-agreement/agreementFormByCompany'),
				name: 'AgreementEditByCompany',
				meta: { title: '编辑租赁公司扣租协议' }
			},
			{
				path: '/rentAgreementByCompany/add',
				component: () => import('@/views/pay-center/rent-agreement/agreementFormByCompany'),
				name: 'AgreementAddByCompany',
				meta: { title: '新增租赁公司扣租协议' }
			}
		]
	},
	{
		path: '/rentAccountDetailListByCompany',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/rentAccountDetailListByCompany/:plan_no',
				component: () =>
					import('@/views/pay-center/rent-account-detail/rentAccountDetailListByCompany'),
				name: 'RentAccountDetailListByCompany',
				meta: { title: '租赁公司扣租入账及划转记录' }
			}
		]
	},
	{
		path: '/admin/v1/driver_core',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/admin/v1/driver_core/driver_core_configuration',
				component: () =>
					import('@/views/operating/driver-core/driver-core-configuration/components/DriverCoreConfigurationEdit'),
				name: 'DriverCoreConfigurationAdd',
				meta: { title: '核心车主配置创建' }
			},
			{
				path: '/admin/v1/driver_core/driver_core_configuration/:activity_id',
				component: () =>
					import('@/views/operating/driver-core/driver-core-configuration/components/DriverCoreConfigurationEdit'),
				name: 'DriverCoreConfigurationEdit',
				meta: { title: '核心车主配置' }
			},
			{
				path: '/admin/v1/driver_core/driver_core_configuration/data/list',
				component: () =>
					import('@/views/operating/driver-core/driver-core-configuration/components/DriverCoreConfigurationData'),
				name: 'DriverCoreConfigurationData',
				meta: { title: '查看核心车主活动数据' }
			}
		]
	},
	{
		path: '/cityConfiguration',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/cityConfiguration/config',
				component: () => import('@/views/coupon-system/coupon-city-week/config-form'),
				name: 'cityConfigurationConfig',
				meta: { title: '配置分城市配置优惠券' }
			}
		]
	},
	{
		path: '/peak-transport/detail/:rule_id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/peak-transport/detail/:rule_id',
				component: () => import('@/views/operating/peak-transport/detail'),
				name: 'PeakTransportDetail',
				meta: { title: '尖峰时刻配置' }
			}
		]
	},
	{
		path: '/fence/recommend/fence-bind-recommend',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/fence/recommend/fence-bind-recommend',
				component: () => import('@/views/fence/recommend/fence-bind-recommend'),
				name: 'fenceBindRecommend',
				meta: { title: '配置CAPP指定点' }
			}
		]
	},
	{
		path: '/marketing_system/activity-center/big-wheel/big-wheel-record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/marketing_system/activity-center/big-wheel/big-wheel-record',
				component: () =>
					import('@/views/marketing_system/activity-center/big-wheel/big-wheel-record'),
				name: 'BigWheelRecord',
				meta: { title: '活动参与记录' }
			}
		]
	},
	{
		path: '/hotFenceConfig',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/fence/hot-fence/edit'),
				name: 'hotFenceConfig',
				meta: { title: '热区围栏配置' }
			}
		]
	},
	{
		path: '/reconciliaconfigura/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/reconciliaconfigura/edit',
				component: () => import('@/views/pay-center/check/reconciliation-configuration/edit'),
				name: 'ConfigurationEdit',
				meta: { title: '线下录入' }
			}
		]
	},
	{
		path: '/marketing_system/three-parties-code/record-search',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/marketing_system/three-parties-code/record-search',
				component: () => import('@/views/marketing_system/three-parties-code/record-search'),
				name: 'CodeRecordSearch',
				meta: { title: '券码发送查询' }
			}
		]
	},
	{
		path: '/crowd-service/add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/crowd-service/add',
				component: () => import('@/views/strategy-platform/crowd-service/edit'),
				name: 'CrowdServiceAdd',
				meta: { title: '新增-人群服务配置' }
			}
		]
	},
	{
		path: '/crowd-service/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/crowd-service/edit',
				component: () => import('@/views/strategy-platform/crowd-service/edit'),
				name: 'CrowdServiceEdit',
				meta: { title: '人群服务配置' }
			}
		]
	},
	{
		path: '/strategy-config/add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/strategy-config/add',
				component: () => import('@/views/strategy-platform/strategy-config/edit'),
				name: 'StrategyConfigAdd',
				meta: { title: '新增-策略配置' }
			}
		]
	},
	{
		path: '/strategy-config/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/strategy-config/edit',
				component: () => import('@/views/strategy-platform/strategy-config/edit'),
				name: 'StrategyConfigEdit',
				meta: { title: '策略配置' }
			}
		]
	},
	{
		path: '/booking-rate-config/add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/booking-rate-config/add',
				component: () =>
					import('@/views/pay-center/ledger/booking-rate-config/BookingRateConfigEdit'),
				name: 'BookingRateConfigAdd',
				meta: { title: '新增-预约抽佣配置' }
			}
		]
	},
	{
		path: '/booking-rate-config/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/booking-rate-config/edit',
				component: () =>
					import('@/views/pay-center/ledger/booking-rate-config/BookingRateConfigEdit'),
				name: 'BookingRateConfigEdit',
				meta: { title: '编辑-预约抽佣配置' }
			}
		]
	},
	{
		path: '/booking-rate-config/log',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/booking-rate-config/log',
				component: () =>
					import('@/views/pay-center/ledger/booking-rate-config/BookingRateConfigLog'),
				name: 'BookingRateConfigLog',
				meta: { title: '预约抽佣配置记录' }
			}
		]
	},
	{
		path: '/station-orders/manage/add',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/station-orders/manage/add',
				component: () => import('@/views/station-orders/station-orders-manage/edit'),
				name: 'StationOrdersManageAdd',
				meta: { title: '场站接单新增' }
			}
		]
	},
	{
		path: '/station-orders/manage/edit',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/station-orders/manage/edit',
				component: () => import('@/views/station-orders/station-orders-manage/edit'),
				name: 'StationOrdersManageEdit',
				meta: { title: '场站接单详情' }
			}
		]
	},
	{
		path: '/station-orders/disposal-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/station-orders/disposal-list',
				component: () => import('@/views/station-orders/station-orders-manage/disposal-list'),
				name: 'StationOrdersDisposalList',
				meta: { title: '受限司机名单' }
			}
		]
	},
	{
		path: '/strategy-config/whitelist-list',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/strategy-config/whitelist-list',
				component: () => import('@/views/station-orders/station-orders-manage/whitelist-list'),
				name: 'StrategyConfigWhitelistList',
				meta: { title: '策略白名单' }
			}
		]
	},
	{
		path: '/strategy-add-white-list/record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/strategy-add-white-list/record',
				component: () => import('@/views/batch-record/addStrategyWhitelist'),
				name: 'DriverStrategyWhiteListRecord',
				meta: { title: '倍率白名单操作' }
			}
		]
	},
	{
		path: '/add-white-list/record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/add-white-list/record',
				component: () => import('@/views/batch-record/addWhitelist'),
				name: 'DriverWhiteListRecord',
				meta: { title: '优选白名单操作' }
			}
		]
	},
	{
		path: '/driver-fence-white/record',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/driver-fence-white/record',
				component: () => import('@/views/batch-record/driver_white_record'),
				name: 'BatchRecordDriverWhiteRecord',
				meta: { title: '偏好围栏白名单操作' }
			}
		]
	},
	{
		path: '/activity-template/config/:model_id',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/activity-template/config/:model_id',
				component: () =>
					import('@/views/operating/ensure-activity/activity-template-list/DetailConfig'),
				name: 'ActivityTemplateConfig',
				meta: { title: '活动模板配置' }
			}
		]
	},
	{
		path: '/transport/log',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/task/quality_workbench/manual-allocation/DriverCommonLog'),
				name: 'TransportLog',
				meta: { title: '操作日志' }
			}
		]
	}
]
/**
 * the routes that need to be dynamically loaded based on user roles
 */
const basisRouter = {
	Menu: () => import('@/views/system/menu/index'),
	LogCenterStaticDataDictionary: () => import('@/views/system/dataDictionary/index'), // 日志中心静态字典
	Role: () => import('@/views/system/role/index'),
	User: () => import('@/views/system/user/index'),
	Org: () => import('@/views/system/org/index'),
	OperationLog: () => import('@/views/system/log/index'),
	UserLog: () => import('@/views/system/user_log/index'),
	Car: () => import('@/views/transport/car/index'),
	Driver: () => import('@/views/transport/driver/index'), // 司机管理列表
	Peopcar: () => import('@/views/transport/peopwithcar/index'),
	DataLook: () => import('@/views/datalook/index'),
	Geofence: () => import('@/views/fence/geofence'),
	HotFence: () => import('@/views/fence/hot-fence/index'), // 热区围栏列表页
	RegeoFence: () => import('@/views/fence/regeoFence'),
	FenceBindPick: () => import('@/views/fence/pickFence'),
	FenceBindLimit: () => import('@/views/fence/limitFence'),
	FenceBindVirtual: () => import('@/views/fence/virtualFence'),
	FenceBindForbid: () => import('@/views/fence/forbidFence'),
	FenceBindCorrection: () => import('@/views/fence/correctionFence'),
	FenceBindForbidEstimate: () => import('@/views/fence/forbidEstimateFence'),
	FenceBindForbidDispatch: () => import('@/views/fence/forbidDispatchFence'),
	FenceBindForbidFinish: () => import('@/views/fence/forbidFinishFence'),
	FenceBindEstimate: () => import('@/views/fence/estimateFence'),
	cityRuleSet: () => import('@/views/city-rule/index'),
	FenceBindIncomeFloor: () => import('@/views/fence/incomeFloorFence'),
	// 自动生成围栏
	AutoEnclosure: () => import('@/views/fence/autoEnclosure'),
	FenceMutex: () => import('@/views/fence/fenceMutex'),
	DriverServiceDay: () => import('@/views/datalook/driverServiceDay'),
	DriverFloor: () => import('@/views/datalook/driver-floor/index'), //司机保底围栏
	ColdArea: () => import('@/views/fence/cole-area/index'), //保底冷区围栏
	FenceNoOrder: () => import('@/views/fence/no-order/index'), // 不接单围栏
	DriverServiceTotal: () => import('@/views/datalook/driverServiceTotal'),
	DriverDeep: () => import('@/views/datalook/detail'),
	WorkOrder: () => import('@/views/order/workorder'),
	WorkBench: () => import('@/views/examine/index'), //招募审核工作台
	Material: () => import('@/views/material/index'), //人工-合规资料审核
	AIMaterial: () => import('@/views/material/index'), //自动-合规资料审核
	InvoiceManage: () => import('@/views/invoice/index'), // 发票开票管理
	InvoiceDetail: () => import('@/views/invoice/detail'),
	InvoiceCompany: () => import('@/views/invoice/company/companyList'), // 开票明细管理
	InvoiceEditCompany: () => import('@/views/invoice/company/editCompany'), // 公司主体开票编辑/新增
	InvoiceGetCompany: () => import('@/views/invoice/company/getCompany'), // 公司主体开票查看
	InvoiceRouter: () => import('@/views/invoice/agentRouter/agentList'), // 渠道开票管理
	EditAgentRouter: () => import('@/views/invoice/agentRouter/editAgentRouter'), // 渠道开票编辑/新增
	GetAgentRouter: () => import('@/views/invoice/agentRouter/getAgentRouter'), // 渠道开票查看
	InvoiceCity: () => import('@/views/invoice/cityRouter/cityList'), // 城市开票管理
	EditCityRouter: () => import('@/views/invoice/cityRouter/editCityRouter'), // 城市开票编辑/新增
	GetCityRouter: () => import('@/views/invoice/cityRouter/getCityRouter'), // 城市开票查看

	ChangeCar: () => import('@/views/task/changecar'),
	CarConflict: () => import('@/views/task/conflict'),
	FindAccount: () => import('@/views/task/findaccount/index'),
	HeatMap: () => import('@/views/datalook/heatMap'),
	realIncomeFloor: () => import('@/views/datalook/realIncomeFloor'),
	DriverRegister: () => import('@/views/transport/registerdriver'),
	ArchivePoints: () => import('@/views/transport/driver/archive_points'), // 司机大盘
	LaborManage: () => import('@/views/labor/index'),
	LicenseVerifyList: () => import('@/views/batch-record/licenseVerifyList'),
	SettingLicenseVerifyList: () => import('@/views/batch-record/licenseVerifySettingList'),
	ChangeCompany: () => import('@/views/batch-record/changeCompany'),
	ReceiveOrder: () => import('@/views/batch-record/receiveOrder'),
	DriverOnOffLine: () => import('@/views/batch-record/driverOnOffLine'),
	DriverLabels: () => import('@/views/batch-record/driverLabels'),
	RegisterFast: () => import('@/views/batch-record/registerFast'),
	PolicySet: () => import('@/views/face/config'),
	FaceToDo: () => import('@/views/face/review/pending'),
	FaceResolve: () => import('@/views/face/review/resolve'),
	FaceChannel: () => import('@/views/face/channel-config/index'), //渠道人脸配置
	FaceHistory: () => import('@/views/face/history/index'), //人脸识别历史
	ElectronicDriverLicense: () =>
		import('@/views/task/electronic-driver-license/ElectronicDriverLicenseList'), // 任务管理-电子驾驶证
	IMDelRecord: () => import('@/views/batch-record/delRecord'), // 群聊操作记录
	ChatIM: () => import('@/views/groupchat/chat/index'), // 群聊IM-运营端IM
	GroupManage: () => import('@/views/groupchat/manage/index'), // 群聊IM-群组管理
	IMRecord: () => import('@/views/groupchat/manage/record'), // 群聊IM-操作日志
	CoreOwner: () => import('@/views/core-owner/index'), // 核心车主
	CarBrandBase: () => import('@/views/car-brand/car-brand-base'), // 基础配置-车品牌
	CarBrand: () => import('@/views/car-brand/car-brand'), // 基础配置-品牌车型
	DrivingStandard: () => import('@/views/base-set/drivingStandard'), //基础配置-出车标准配置
	DriverAbnormal: () => import('@/views/base-set/driverAbnormal'), //基础配置-司机异常
	DriverBackgroundSet: () => import('@/views/driver-background/set/index'), //基础配置-司机背调配置
	DriverBackgroundResult: () => import('@/views/driver-background/result-list/index'), //基础配置-司机背调记录
	DriverBackgroundBatch: () => import('@/views/driver-background/batch-query/index'), //基础配置-司机背调批量查询记录
	BasicConfigurationLabel: () => import('@/views/base-set/label/index'), // 基础配置--标签管理

	CompRule: () => import('@/views/base-set/comp-rule/index'), //基础配置-合规认证配置
	CitySwitch: () => import('@/views/city-switch/index'), //基础配置-城市开关城
	CitySwitchCross: () => import('@/views/city-switch/city-cross'), //基础配置-城市开关城
	ChannelOnOffLine: () => import('@/views/base-set/channel-onoffline/index'), //基础配置-渠道上下线
	AgentLevelCategory: () => import('@/views/base-set/agent-level-category'), //基础配置-渠道车型库配置
	LicenseVerify: () => import('@/views/license-verify/index'), //任务管理-三方验真

	QueryDriverDetails: () => import('@/views/query-driver/index'), //运力管理-司机查询
	BroadcastList: () => import('@/views/broadcast_manage/broadcastList'), //基础配置-播报管理
	BookingSpeedFee: () => import('@/views/base-set/booking-speedfee/index'), //基础配置-高速费-比例配置
	BookingHolidaysSpeedFee: () => import('@/views/base-set/booking-holidays-speedfee/index'), //基础配置-高速费-比例配置
	CityOutboundTimeConfig: () => import('@/views/base-set/city-outbound-time-config/index'), //基础配置-接机订单最小出站时间配置
	OPEN_CITY_MENU: () => import('@/views/base-set/open-city/index'), // 基础配置-开城管理
	BlackList: () => import('@/views/transport/blacklist/index'),
	WhiteList: () => import('@/views/transport/whitelist/index'),
	StrategyWhiteList: () => import('@/views/transport/whitelist/strategy_index'),
	FuelTypeCarWhiteList: () => import('@/views/transport/whitelist/fuel-type-car-whitelist.vue'), // 燃料类型车辆白名单
	CarWhiteList: () => import('@/views/transport/whitelist/car-whitelist'), // 车辆白名单
	DriverWhiteList: () => import('@/views/transport/whitelist/driver-whitelist'), // 司机白名单
	ChannelOrderBlacklist: () => import('@/views/transport/channel-blacklist/index'), // 渠道派单黑名单
	DriverAddBlacklist: () => import('@/views/batch-record/addBlacklist'),
	DriverAddWhitelist: () => import('@/views/batch-record/addWhitelist'),
	DriverAddStrategyWhitelist: () => import('@/views/batch-record/addStrategyWhitelist'),
	BatchChannelOrderBlacklist: () => import('@/views/batch-record/channel-order-blacklist'), // 渠道派单黑名单批量操作
	AccountManage: () => import('@/views/pay-center/account/index'),
	AccountDetailManage: () => import('@/views/pay-center/account/accountDetail'),
	AccountAllDetailManage: () => import('@/views/pay-center/account/accountAllDetail'), // 账户管理-流水详情
	VendorCashManage: () => import('@/views/pay-center/cash/vendorList'),
	DriverCashManage: () => import('@/views/pay-center/cash/driverList'),
	// 提现管理
	withdrawSet: () => import('@/views/pay-center/cash/withdrawSet'),
	//提现设置---默认编辑
	defaultEdit: () => import('@/views/pay-center/cash/compont/default_edit'),
	//提现设置---特殊编辑
	specialEdit: () => import('@/views/pay-center/cash/compont/special_edit'),
	AdjuestOrderList: () => import('@/views/pay-center/adjust-order/index'),
	AdjustOrderBatchTask: () => import('@/views/pay-center/adjust-order/batchTask'),
	PlatformStats: () => import('@/views/pay-center/platform/stats'),
	CompanyList: () => import('@/views/company/index'), // 车队列表
	WorkOrderGroup: () => import('@/views/work-order/transfer-group/index.vue'),
	WorkOrderTemplate: () => import('@/views/work-order/template/index.vue'),
	WorkOrderLabel: () => import('@/views/work-order/workOrderLabel/index.vue'),
	WorkChannelAging: () => import('@/views/work-order/work-channel-aging/index.vue'),
	WorkOrderPunishLabel: () => import('@/views/work-order/workOrderPunishLabel/index.vue'),
	WorkOrderResponsibleLabel: () => import('@/views/work-order/workOrderResponsibleLabel/index.vue'),
	WorkOrderList: () => import('@/views/work-order/work-order-list/index.vue'),
	AgentAppeal: () => import('@/views/work-order/agent-appeal/index'),
	WorkOrderBatchRecordingCreateDisposeList: () =>
		import('@/views/work-order/batch-recording/work-order-create-dispose/index'), // 批量创建&处理工单
	WorkOrderLabelMapping: () => import('@/views/work-order/work-order-label-mapping/index'), // 工单标题映射
	WorkAppealReassign: () => import('@/views/work-order/work-appeal-reassign/index'), // 司机端申诉配置（扶摇）
	/**
	 * 质检管理
	 * */
	// 个人质检
	WorkOrderQcList: () => import('@/views/quality/qualityList/index.vue'),
	// 全部质检
	WorkOrderQcedList: () => import('@/views/quality/allQualityList/index.vue'),
	// 客服数据
	WorkOrderDataList: () => import('@/views/work-order/work-order-data/index.vue'),
	// 客服外呼配置
	OutboundCallSet: () => import('@/views/quality/outbound-call-set/index.vue'),
	// 高德申诉
	GaoDeAppeal: () => import('@/views/work-order/GaoDeAppeal/index.vue'),
	// 上下线列表
	WorkOrderUserStatusList: () => import('@/views/work-order/top-bottom-line-list/index.vue'),

	CompanyBelong: () => import('@/views/company/belong'), // 公海司机归属
	DriverPayment: () => import('@/views/pay-center/payment/driverAlipay'), // 司机支付管理
	TransferManage: () => import('@/views/pay-center/payment/transfer'), //  账户余额管理
	CompanyBills: () => import('@/views/pay-center/company/vendorDetail'), // 车队账单管理
	CompanyWithdrawInfo: () => import('@/views/pay-center/company/companyInfo'), // 车队提现管理
	BillCheckTaskList: () => import('@/views/pay-center/check/taskList'), // 对账任务管理
	BillCheckSummaryList: () => import('@/views/pay-center/check/taskList'), // 对账结果管理
	ReconciliaConfiguration: () =>
		import('@/views/pay-center/check/reconciliation-configuration/index'), // 对账配置管理
	CooperationChannels: () => import('@/views/pay-center/cooperation-channels/index'), // 对账结果管理
	BillCheckUploadList: () => import('@/views/pay-center/check/uploadList'), // 上传管理
	EditUploadRelation: () => import('@/views/pay-center/check/editUploadRelation'), // 编辑映射关系
	// 补扣记录
	FillDeductionRecord: () => import('@/views/work-order/fill_deduction/fill_deduction_record'),

	OrderSearch: () => import('@/views/one-table-line/new/order-search/OrderSearchList'), // 新客服系统-订单查询
	// 订单中心
	OrderManage: () => import('@/views/order-center/real_order/list/manage'), // 订单管理
	AssignedManually: () => import('@/views/order-center/assigned_manually/index'), // 待人工派车订单
	OrderSeconds: () => import('@/views/order-center/order_cancel/index'), // 渠道秒取消
	OrderAlert: () => import('@/views/order-center/real_order/list/orderAlert'), // 订单预警
	RealOrderChargeDetail: () => import('@/views/order-center/real_order/detail/fee_detail'), // 计费详情
	AgentRuleList: () => import('@/views/pay-center/ledger/agentRuleList'), // 清分-获客渠道配置
	AgentCommissionStatistics: () => import('@/views/pay-center/ledger/commission-statistics/index'), // 渠道佣金统计
	LedgerStats: () => import('@/views/pay-center/ledger/ledgerStats'), // 清分监控
	AgentCommission: () => import('@/views/pay-center/ledger/agent-commission/index'), // 阶梯抽佣配置
	BookingRateConfig: () =>
		import('@/views/pay-center/ledger/booking-rate-config/BookingRateConfigList'), // 预约抽佣配置
	CityIPKCfg: () => import('@/views/pay-center/ledger/ipk_config'), // IPK配置
	LedgerAggregateList: () => import('@/views/pay-center/ledger/aggregateList'), // 清分记录
	CommissionFormula: () => import('@/views/pay-center/ledger/commission-formula/index'), // 抽佣公式配置
	ComplianceBottom: () => import('@/views/pay-center/ledger/compliance-bottom/index'), // 合规兜底配置
	PayBottom: () => import('@/views/pay-center/ledger/pay-bottom/index'), // 支付兜底配置
	// 财务中心-收款管理
	SettleList: () => import('@/views/pay-center/settle/settleList'), // 收款记录列表
	SettleBatchTask: () => import('@/views/pay-center/settle/batchTask'), // 录入任务列表
	SettleDetail: () => import('@/views/pay-center/settle/settleDetail'), // 查看收款订单明细

	// 出行系统
	driverMag: () => import('@/views/travel/driver/index.vue'),
	carMag: () => import('@/views/travel/car/index.vue'),
	DriverPosition: () => import('@/views/driver-position/index'), //出行系统-司机实时位置
	DriverTrajectory: () => import('@/views/driver-trajectory/index'), //出行系统-司机轨迹
	TravelWorkOrderList: () => import('@/views/travel-work-order/index'), //出行系统-客诉工单管理
	OrderInterNet: () => import('@/views/travel-ststay/index'), //出行系统-订单信息管理
	TravelCarInspectRecord: () => import('@/views/travel/car-inspect-record/index'), //出行系统-车辆抽检
	CXDriverVaccine: () => import('@/views/epidemic-prevention/vaccine/index'),
	CXDriverNucleic: () => import('@/views/epidemic-prevention/nucleic/index'),
	CXHealthCode: () => import('@/views/epidemic-prevention/health-code/index'),
	CXVenueCode: () => import('@/views/epidemic-prevention/venue-code/index'),

	// 账户费控
	RiskGroup: () => import('@/views/pay-center/risk-group/list'), // 费控列表

	// 履约模块
	RentContractManage: () => import('@/views/pay-center/rent-contract/index'), // 租赁合同列表
	RentContractBatchTask: () => import('@/views/pay-center/rent-contract/batchTask'), // 任务列表
	FreezePlanSummaryListManage: () => import('@/views/pay-center/rent-freeze-plan/planSummaryList'), // 冻结计划摘要列表
	RentAgreementList: () => import('@/views/pay-center/rent-agreement/agreementList.vue'), // 签约协议列表
	RentPlanList: () => import('@/views/pay-center/rent-plan/planList.vue'), // 扣租计划列表
	RentBill: () => import('@/views/pay-center/rent-bill/rentBill.vue'), // 支付宝扣租对账管理
	PayAgentBill: () => import('@/views/pay-center/pay-agent-bill/payAgentBill.vue'), // 渠道交易对账管理
	// 运力公司-租赁合同
	TraRentContractManage: () => import('@/views/pay-center/rent-contract/companyIndex'), // 租赁合同列表
	TraRentContractBatchTask: () => import('@/views/pay-center/rent-contract/companyBatchTask'),
	CompanyFreezeSummaryManage: () =>
		import('@/views/pay-center/rent-freeze-plan/companyPlanSummaryList'), // 运力-冻结计划摘要列表
	RentAgreementListByCompany: () =>
		import('@/views/pay-center/rent-agreement/agreementListByCompany.vue'), // 租赁公司签约协议列表
	RentPlanListByCompany: () => import('@/views/pay-center/rent-plan/planListByCompany.vue'), // 租赁公司扣租计划列表
	/**
	 * 定价系统
	 * */
	CapturePriceManage: () => import('@/views/capture-the-price/index'), // 抓价管理
	ExperimentalPriceManage: () => import('@/views/experimental-price/index'), // 实验价格管理
	FlowManage: () => import('@/views/flow-manage/index'), // 流量管理

	PricingSystemAccountingConfigurationHighFee: () =>
		import('@/views/pricing-system/accounting-configuration/high-fee/index'), // 高温费配置
	PricingSystemAccountingConfigurationCrossCity: () =>
		import('@/views/pricing-system/accounting-configuration/cross-city/index'), // 跨城费
	LowIPKSettings: () => import('@/views/pricing-system/low-ipk-settings/index'), // 低IPK设置
	/**
	 * 调度系统
	 * */
	ComplianceConfig: () => import('@/views/dispatch-system/compliance-config/ComplianceConfigList'), // 惠享补贴配置
	ComplianceModel: () => import('@/views/dispatch-system/compliance-model/ComplianceModelList'), // 惠享补贴模板
	PREORDER_SETTING_MENU: () => import('@/views/dispatch-system/serial-order/index.vue'), // 连环单配置
	OrderStandardSet: () => import('@/views/dispatch-system/order-standard/index'), // 订单标准配置
	WeightCoefficientSet: () => import('@/views/dispatch-system/weight-coefficient/index'), // 权重系数配置
	ChannelLien: () => import('@/views/dispatch-system/channel-lien/index'), // 渠道留置
	JointDecision: () => import('@/views/dispatch-system/joint_decision/index'), // 联合决策
	SubcontractWhiteList: () => import('@/views/dispatch-system/subcontract/white-list/index'), // 包干白名单配置
	SubcontractAccess: () => import('@/views/dispatch-system/subcontract/access/index'), // 准入配置
	SubcontractBlackList: () => import('@/views/dispatch-system/subcontract/blacklist/index'), // 包干黑名单
	OnePriceConfigurationList: () =>
		import('@/views/scheduling_system/one_price_configuration/index'), // 一口价配置
	BreatheScale: () => import('@/views/dispatch-system/breathe-scale'), // 呼吸机配置
	SupplyDemandMarket: () => import('@/views/dispatch-system/supply-demand-market'), // 供需大盘
	ConvenientRoadSetting: () => import('@/views/dispatch-system/convenient-road-setting'), // 顺路单配置
	SubsidyEconomicConfig: () => import('@/views/dispatch-system/subsidy-economic-config/index'), // 补贴经济配置
	SUBSIDY_ECONOMIC_CONFIG_MENU_NEW: () =>
		import('@/views/dispatch-system/subsidy-economic-config-new/index'), // 补贴经济配置(新)
	// 运营系统-权益管理
	// 加速卷列表
	AcceleratorCard: () => import('@/views/preferential_card/accelerator_card/index'),
	PaymentBill: () => import('@/views/pay-center/check/paymentBill'), // 支付对账管理
	// 运营系统-活动管理
	SingleActivityList: () =>
		import('@/views/operating/activity_management/single_activity/index.vue'),
	PrizeActivityList: () => import('@/views/operating/activity_management/prize_activity/index.vue'),
	AdvanceTaskListManage: () => import('@/views/pay-center/advance_risk_task/taskList'),
	OrderRiskListManage: () => import('@/views/pay-center/advance_risk_task/orderRiskList'),
	DriverRecommendDriver: () => import('@/views/operating/driver-recommend-driver/index'), // 司推司配置
	NewDriverMarketing: () => import('@/views/operating/new-driver-marketing/index'), // 新司机奖励
	EnsureActivity: () => import('@/views/operating/ensure-activity/index'), // 司推司配置
	EnsureSprint: () => import('@/views/operating/ensure-sprint/index'), // 保底冲单活动
	PeakTransport: () => import('@/views/operating/peak-transport'), // 尖峰时刻
	ACTIVITY_CENTER_ORDER_SETTING: () => import('@/views/operating/order-setting'), // 保底接单设置配置
	ACTIVITY_CENTER_ORDER_BARGIN_SETTING: () => import('@/views/operating/order-bargin-setting'), // 兼容特惠单分段配置
	DriverIncomeGuide: () => import('@/views/operating/driver-income-guide/index'), // 车主高收入指南系数
	StationOrdersManage: () => import('@/views/station-orders/station-orders-manage'), // 场站订单管理
	ArtificialAddScore: () => import('@/views/yg-score/artificial-add-score/ArtificialAddScoreList'), // 人工加分
	DRIVER_SETTING_PLAT_IPK: () =>
		import('@/views/marketing_system/driver-setting-platform/DriverSettingPlatIpk'), // 惠享指派参数配置-IPK
	DRIVER_SETTING_PLAT_MILE: () =>
		import('@/views/marketing_system/driver-setting-platform/DriverSettingPlatMile'), // 惠享指派参数配置-公里数
	OperatingDriverCoreConfiguration: () =>
		import('@/views/operating/driver-core/driver-core-configuration/index'), // 核心车主配置
	OperatingDriverCoreAuth: () => import('@/views/operating/driver-core/owner-auth/index'), // 核心车主-人工授权
	PrivilegeExplain: () => import('@/views/operating/driver-core/privilege-explain'), // 核心车主-权益说明
	// 运营系统-限行
	TrafficRestriction: () =>
		import('@/views/operations-system/restriction/traffic-restriction/index'), // 限行配置
	MessageTasks: () => import('@/views/operations-system/message-center/message-tasks/index'), // 消息任务列表
	/**
	 * 虚拟接配置
	 */
	NoVirtualTime: () => import('@/views/virtual-order/novirtual-time/index'), // 不虚拟接时间
	VirtualMinMoney: () => import('@/views/virtual-order/min-money/index'), // 虚拟接最小金额
	BatchOperationMinMoney: () => import('@/views/virtual-order/operation-record/index'), // 虚拟接开始时间
	VirtualAccept: () => import('@/views/virtual-order/virtual-accept/index'), // 虚拟接开始时间
	/**
	 * 实时计价库存
	 */
	DefaultStartEndProportion: () => import('@/views/realtime-account/default-set/index'), // 默认比例配置
	ArtificialStartEndProportion: () => import('@/views/realtime-account/artificial-set/index'), // 库存上限
	StartHiveStock: () => import('@/views/realtime-account/start-hive/index'), // 起点蜂巢库存
	EndHiveStock: () => import('@/views/realtime-account/end-hive/index'), // 终点蜂巢库存
	OrderMileageStock: () => import('@/views/realtime-account/order-mileagestock/index'), // 下单历程库存比例
	/**
	 * 预约转即时
	 */
	MinuteConf: () => import('@/views/to-real/minute-conf/index'), // 转即时分钟配置
	Factor: () => import('@/views/to-real/factor/index'), // 转即时车型系数
	/**
	 * 司机培训
	 */
	SafetyResponsibilityStatement: () =>
		import('@/views/driver-train/safety-responsibility-statement/index'), // 安全责任书签署
	DriverTrainManage: () => import('@/views/driver-train/manage/index'), // 培训管理
	DriverTrainQuery: () => import('@/views/driver-train/query/index'), // 培训查询
	DriverTrainTaskExport: () => import('@/views/driver-train/export/task_export'), // 司机培训任务导出
	DriverTrainFileExport: () => import('@/views/driver-train/export/file_export'), // 司机培训档案导出
	DriverTrainStatistics: () => import('@/views/driver-train/statistics/index'), // 培训统计
	DriverTrainCourseCenterList: () => import('@/views/driver-train/course-center/index'), // 培训课程中心配置
	CourseManageList: () => import('@/views/driver-train/course-manage/list'), // 课程管理列表
	// 财务系统-垫付白名单管理
	AdvanceWhiteRuleList: () => import('@/views/pay-center/white-rule/ruleList'), // 垫付白名单
	WhiteRuleTaskManage: () => import('@/views/pay-center/white-rule/batchTask'), // 白名单录入任务管理
	/**
	 * 工系统工具
	 */
	AmapTrajectory: () => import('@/views/utils-system/amap-trajectory/index'), // 轨迹工具
	MapPathPlan: () => import('@/views/utils-system/map-path/index'), // 轨迹工具
	StaffBackground: () => import('@/views/utils-system/staff-background/index'), // 员工背调
	JRYGGpt: () => import('@/views/utils-system/jryg-gpt/index.vue'), // 阳光GPT
	ToolSystemPortrayalCenterLabel: () => import('@/views/utils-system/portrayal-center/index'), // 画像中心标签管理
	LOG_BURYPOINTALL_AUTO: () => import('@/views/system/log-burypoint/index.vue'), // 日志埋点实时采集
	AssignedFence: () => import('@/views/fence/assignedFence.vue'), // 指派围栏

	FenceRecommend: () => import('@/views/fence/recommend/index'), // CAPP指定点管理

	// NPS调研
	NpsSurvey: () => import('@/views/system/nps/index.vue'),
	/**
	 * 营销系统
	 */
	SeckillEvent: () => import('@/views/coupon-system/seckill/index'), // 社群秒杀营销活动0413
	CouponManage: () => import('@/views/coupon-system/coupon-manage/index'), // 优惠券管理
	CouponTagManage: () => import('@/views/coupon-system/coupon-tag-manage'), // 优惠券标签管理
	GiftManage: () => import('@/views/coupon-system/gift-manage/index'), // 礼包管理
	CouponGive: () => import('@/views/coupon-system/coupon-give/index'), // 发放优惠券
	CouponEvent: () => import('@/views/coupon-system/coupon-event/index'), // 活动关联券包
	WeekSend: () => import('@/views/coupon-system/week-send/index'), // 每周自动发券
	ActivityNorm: () => import('@/views/coupon-system/activity-norm/index'), // 领券活动
	AppletsSeckill: () => import('@/views/coupon-system/applets-seckill/index'), // 小程序秒杀
	CappReleasePosition: () => import('@/views/capp-marketing/release-position/index'), // 资源位置管理
	PictureLink: () => import('@/views/marketing_system/picture-link'), // 生成图片链接
	AttentionTiktok: () => import('@/views/marketing_system/attention-tiktok'), // 抖音小程序引导关注
	LiveBroadcastConfig: () => import('@/views/marketing_system/live-broadcast-config'), // 抖音小程序配置直播
	ThreePartiesCode: () => import('@/views/marketing_system/three-parties-code'), // 三方兑换码管理
	QwChannelCode: () => import('@/views/marketing_system/qw-channel-code'), // 企微群渠道码管理
	ShortChain: () => import('@/views/marketing_system/short-chain'), // 营销短链服务
	APICouponConfigList: () => import('@/views/marketing_system/api-coupon-config/CouponConfigList'), // API发券设置
	APICouponChannelList: () =>
		import('@/views/marketing_system/api-coupon-channel/CouponChannelList'), // API发券渠道管理
	APICouponList: () => import('@/views/marketing_system/api-coupon/CouponList'), // API发券记录
	CarTypeCouponConfig: () =>
		import('@/views/marketing_system/car-type-coupon-config/CarTypeCouponConfigList'), // 惠享车型优惠券配置
	MarketingCityCouponsList: () => import('@/views/coupon-system/coupon-city/index'), // 城市发卷
	CityUserDownload: () => import('@/views/coupon-system/coupon-city-user/index'), // 城市用户id下载
	MarketingCouponCityConfigurationList: () =>
		import('@/views/coupon-system/coupon-city-week/index'), // 城市发卷配置
	MarketingSystemCAPPSingle: () => import('@/views/marketing_system/capp/capp_single/index'), // capp黑名单
	CappWhite: () => import('@/views/marketing_system/capp/capp-white/index'), // capp白名单
	UseridFind: () => import('@/views/marketing_system/uid-find/index'), // uid查询
	MemberInfo: () => import('@/views/marketing_system/member-info/index'), // 会员信息查询
	MessagePushSubscribe: () => import('@/views/marketing_system/message-push/subscribe/index'), // 会员信息查询
	MessageRobotConfig: () =>
		import('@/views/marketing_system/message-push/qw-message-robot-config/MessageRobotConfigList'), // 企微消息机器人配置
	// 消息触达 - 企微AI推送文案配置
	WECOM_AI_PUSH_COPY_CONFIGURATION: () =>
		import('@/views/marketing_system/message-push/ai-copy-config/index'),
	// 消息触达 - 企微AI时间配置
	COMPANY_WECHAT_AI_TIME_SETTING: () =>
		import('@/views/marketing_system/message-push/ai-time-config/index'),
	CouponGoodsManage: () =>
		import('@/views/marketing_system/goods-manage/coupon-goods-manage/index'), // 卡券商品管理
	CouponGoodsOrder: () => import('@/views/marketing_system/goods-manage/coupon-goods-order/index'), // 抖音卡券购买记录
	SHSCouponGoodsOrder: () =>
		import('@/views/marketing_system/goods-manage/coupon-goods-order/index'), // 小红书卡券购买记录
	ActivityCoupon: () => import('@/views/marketing_system/activity-center/activity-coupon/index'), // 发券活动
	NewUserCouponEvent: () => import('@/views/coupon-system/new-user-coupon-event/index'), // 分渠道配置新人礼包
	CityThresholdRealOrder: () => import('@/views/marketing_system/city-threshold/index'), // 分城市配置一口价门槛
	WxworkJob: () => import('@/views/marketing_system/wxwork-job/index'), // 企微1v1群发
	CAPPPushMessage: () => import('@/views/marketing_system/app-push/index'), // APP push
	BigWheel: () => import('@/views/marketing_system/activity-center/big-wheel/index'), // 社群抽奖
	DOUYIN_AFTER_SALE_SCENE_MSG: () =>
		import('@/views/marketing_system/douyin-after-sale-scene-msg/index'), // 抖音售后场景消息
	//外呼系统
	SystemOutsideOutboundList: () => import('@/views/outside-the-system-call/outbound-task/index'), //外呼任务管理
	SystemCallOutTaskUserList: () => import('@/views/outside-the-system-call/call_out_user/index'), //外呼任务
	MarketingSystemCouponUser: () => import('@/views/coupon-system/user-coupon/index'), // 用户优惠券
	CouponExpansionConfig: () => import('@/views/coupon-system/expansion-config/ExpansionList'), // 优惠券膨胀配置
	ActivityZFB: () => import('@/views/coupon-system/zfb-marketing/index'), // 支付宝引流领券活动
	COMPANY_WECHAT_YTX_SETTING: () => import('@/views/marketing_system/ytx-setting/index'), // 企微易通行配置

	// 活动中心
	SHARE_COUPON_ACTIVITY_MENU: () =>
		import('@/views/marketing_system/activity-center/shared-coupon/index'), // 可分享优惠券
	/**
	 * 司机防疫管理
	 */
	DriverVaccine: () => import('@/views/epidemic-prevention/vaccine/index'), //
	DriverNucleic: () => import('@/views/epidemic-prevention/nucleic/index'),
	HealthCode: () => import('@/views/epidemic-prevention/health-code/index'),
	VenueCode: () => import('@/views/epidemic-prevention/venue-code/index'),
	ChargeBack: () => import('@/views/to-real/charge-back/index'),
	RiskAction: () => import('@/views/work-order/risk-center/risk-action/index'),
	RiskModule: () => import('@/views/work-order/risk-center/risk-module/index'),
	RiskRule: () => import('@/views/work-order/risk-center/risk-rule/index'),
	RiskStrategy: () => import('@/views/work-order/risk-center/risk-strategy/index'),
	RiskStrategyGroup: () => import('@/views/work-order/risk-center/risk-strategy-group/index'),
	/**
	 * 预约预警配置
	 */
	OrderAppointmentPick: () => import('@/views/order-warn/order_appointment_pick/index'), //预约实时计价接驾
	//  OrderAppointmentPlace:() => import('@/views/order-warn/order_appointment_place/index'),//预约实时计价就位
	OrderAppointmentWarn: () => import('@/views/order-warn/order_appointment_warn/index'), //预约实时计价预警
	OrderBookPick: () => import('@/views/order-warn/order_book_pick/index'), //预约一口价接驾
	OrderBookPlace: () => import('@/views/order-warn/order_book_place/index'), //预约一口价就位
	OrderBookWarn: () => import('@/views/order-warn/order_book_warn/index'), //预约一口价预警
	RiskFactor: () => import('@/views/order-warn/risk_factor/index'), //风险因素信息
	TriggerEvent: () => import('@/views/order-warn/trigger_event/index'), //触发事件信息

	/**
	 * 风控中心
	 */
	RiskList: () => import('@/views/work-order/risk-center/risk-list/index'),
	RiskListRehearse: () => import('@/views/work-order/risk-center/risk-list-rehearse/index'),
	RiskAdvancePayment: () => import('@/views/work-order/risk-center/risk-advance-payment/index'),
	WorkOrderRiskCenterDriverGrade: () =>
		import('@/views/work-order/risk-center/risk-driver-grade/index'), // 司机等级

	AdvanceRiskRule: () => import('@/views/work-order/advance-risk-rule/index'), // 垫付风控规则
	/**
	 * 一口价取消补偿配置
	 */
	OrderBookCancel: () => import('@/views/order-book-cancel/index'), // 一口价取消补偿配置
	/**
	 * 一口价倍率配置
	 */
	BookMultiplyingPower: () => import('@/views/order-book/book-multiple-configuration/index'), // 一口价取消补偿配置
	CompliantConfigurationOfChannelCity: () =>
		import('@/views/order-book/compliant-configuration-of-channel-city/index'), // 渠道城市合规配置
	/**
	 * 预约实时计价派单配置
	 */
	//  ---------实时计价派单---------
	IssuingRange: () => import('@/views/order-dispatch/Issuing-ranges/index'), // 发单范围
	ImmediateIssuing: () => import('@/views/order-dispatch/immediate-issuing/index'), //转即时发单范围
	IssuingMode: () => import('@/views/order-dispatch/Issuing-mode/index'), //发单模式（0-24）
	IssuingModePuls: () => import('@/views/order-dispatch/Issuing-mode-puls/index'), //发单模式（24以上）
	SafetyTime: () => import('@/views/order-dispatch/safety-time/index'), //安全时间增幅
	IssuanceRound: () => import('@/views/order-dispatch/Issuance-round/index'), //1小时内发单轮次间隔
	FirstIssuanceRound: () => import('@/views/order-dispatch/first-Issuance-round/index'), //首轮发单首轮司机数
	IssuanceRoundTime: () => import('@/views/order-dispatch/Issuance-round-time/index'), //发单司机活跃时间

	//  -----------一口价派单------------
	PriceIssuingRange: () => import('@/views/order-price-dispatch/price-Issuing-ranges/index'), // 发单范围
	PriceImmediateIssuing: () => import('@/views/order-price-dispatch/price-immediate-issuing/index'), //转即时发单范围

	// ----------实时计价虚拟接配置--------
	AgentSwitch: () => import('@/views/ordre-virtual-configuration/agent-switch/index'), // 渠道虚拟接开关
	AgentSwitchTime: () => import('@/views/ordre-virtual-configuration/agent-switch-time/index'), // 渠道虚拟接时间
	CitySwitchs: () => import('@/views/ordre-virtual-configuration/city-switch/index'), // 城市虚拟接开关
	CarVirtualInformation: () =>
		import('@/views/ordre-virtual-configuration/car-virtual-Information/index'), // 虚拟车辆信息
	CarVirtualLog: () => import('@/views/ordre-virtual-configuration/car-virtual-log/index'), // 虚拟车辆日志

	// --------实时计价其他配置----------
	ReassignmentFee: () => import('@/views/order-reassignment-fee/index'), // 改派费
	//----------------------------------------------------------------------//
	/**
	 * 任务管理
	 * */
	TaskAudit: () => import('@/views/task/driver_video_audit/index'), // 验车视频审核
	// 批量信息导出记录
	BatchInformaion: () => import('@/views/batch-record/information.vue'),
	// 批量解绑操作
	BatchUnbind: () => import('@/views/batch-record/batchUnbind.vue'),
	/*
	 * 工具类
	 * */
	ToolSystemKeyDecrypt: () => import('@/views/tool_system/encrypt/index'), // 加密解密
	RealtimeAgentManage: () => import('@/views/system/agent/index'), // 渠道管理
	TaskCarJoin: () => import('@/views/task/no_car_join/index'), // 无车加盟
	TaskAiCheckWorkbench: () => import('@/views/task/ai_check_workbench/recruit_workbench/index'), // ai审核工作台
	TaskQualityWorkbench: () => import('@/views/task/quality_workbench/recruit_workbench/index'), // 招募质检工作台
	SpotCheckConfig: () => import('@/views/task/quality_workbench/spot-check-config/ConfigList'), // 质检管理-抽检配置
	ManualAllocation: () => import('@/views/task/quality_workbench/manual-allocation/AllocationList'), // 质检管理-人工分配
	TaskAiCheckWorkbenchTransfer: () =>
		import('@/views/task/ai_check_workbench/transfer_workbench/index'), // ai换车审核
	TaskQualityWorkbenchTransfer: () =>
		import('@/views/task/quality_workbench/transfer_workbench/index'), // 换车质检

	TaskAiCheckWorkbenchInfoChange: () =>
		import('@/views/task/ai_check_workbench/info_change_workbench/index'), // AI信息变更
	ChangeInfo: () => import('@/views/task/changeinfo/index_new'), // 人工信息变更
	TaskQualityWorkbenchInfoChange: () =>
		import('@/views/task/quality_workbench/info_change_workbench/index'), // 信息变更质检工作台
	NoCrime: () => import('@/views/task/no_crime/index.vue'), // 无犯罪证明审核
	AdvancedApprove: () => import('@/views/base-set/advaced_approve/index'), // 高级认证配置
	DriverDataExport: () => import('@/views/driver_data_export/index'), // 司机服务数据导出

	/**
	 * quick_bi
	 * */
	QuickBiList: () => import('@/views/quick-bi-system/index'), // quick_bi 管理列表

	SystemUserRemoteCollect: () => import('@/views/system/user_remote_collect/index'), // 异地登录监控

	BatchRecordDriverWhite: () => import('@/views/batch-record/driver_white_record'), // 司机偏好围栏白名单

	// 运营系统-策略平台
	CrowdService: () => import('@/views/strategy-platform/crowd-service/index'), // 人群服务
	StrategyConfig: () => import('@/views/strategy-platform/strategy-config/index'), // 策略配置后台
	// 运营系统-车辆抽检
	CarInspectConfig: () => import('@/views/operations-system/car-inspect/car-inspect-config/index'), // 车辆抽检策略
	CarInspectRecord: () => import('@/views/operations-system/car-inspect/car-inspect-record/index'), // 车辆抽检审核
	DrivingVideo: () => import('@/views/operations-system/car-inspect/driving-video/index'), // 出车核验
	StickInspect: () => import('@/views/operations-system/car-inspect/stick-inspect/index'), // 车贴抽检审核

	v3: () => import('@/views/v3-container/index')
}
let quickBiRouter = {}
if (process.env.NODE_ENV == 'production') {
	quickBiRouter = {
		/**
		 * Bi系统
		 * */
		// 运营大盘
		QuickBiOperationInstant: () => import('@/views/quick-bi-system/operation/instant/daily/index'), // 运营看板
		QuickBiOperationPrice: () => import('@/views/quick-bi-system/operation/instant/price/index'), // 即时一口价日报
		QuickBiOperationRealTime: () =>
			import('@/views/quick-bi-system/operation/instant/real_time/index'), // 实时数据看板
		QuickBiOperationHalfHour: () =>
			import('@/views/quick-bi-system/operation/instant/half_hour/index'), // 半小时数据看板
		QuickBiOperationCapacityRealTIme: () =>
			import('@/views/quick-bi-system/operation/capacity/real_time/index'), // 运力运营-实时运力看板
		QuickBiOperationCapacityIncreasingly: () =>
			import('@/views/quick-bi-system/operation/capacity/increasingly/index'), // 运力运营-运力日趋看板
		QuickBiOperationBillingPeriod: () =>
			import('@/views/quick-bi-system/operation/billing/period/index'), // 计费大盘-时段看板
		QuickBiOperationBillingCompensation: () =>
			import('@/views/quick-bi-system/operation/billing/compensation/index'), // 计费大盘-补偿看板
		QuickBiOperationBillingDaily: () =>
			import('@/views/quick-bi-system/operation/billing/daily/index'), // 计费大盘-计费日报
		QuickBiOperationActivityDepartment: () =>
			import('@/views/quick-bi-system/operation/activity/department/index.vue'), // 活动运营-司推司活动
		QuickBiOperationServiceExperienceDriver: () =>
			import('@/views/quick-bi-system/operation/service_experience/driver/index'), // 服务体验-司机体验指标
		QuickBiOperationOrderAnalysis: () =>
			import('@/views/quick-bi-system/operation/order/analysis/index'), // 订单分析

		//  财务大盘
		QuickBiFinancialDailyChart: () => import('@/views/quick-bi-system/financial/daily_chart/index'), // 财务日报图表
		QuickBiFinancialProfits: () => import('@/views/quick-bi-system/financial/profits/index'), // 利润监控
		QuickBiFinancialDailyKanban: () =>
			import('@/views/quick-bi-system/financial/daily_kanban/index'), // 财务日报看板
		QuickBiFInancialDailyContrast: () =>
			import('@/views/quick-bi-system/financial/daily_contrast/index'), // 财务日报对比
		QuickBiFinancialSupplement: () => import('@/views/quick-bi-system/financial/supplement/index'), // 倒补差升级
		QuickBiFinancialProfit: () => import('@/views/quick-bi-system/financial/profit_trends/index'), // 财务利润趋势报表
		QuickBiFinancialGuarantee: () => import('@/views/quick-bi-system/financial/guarantee/index'), // 保底活动
		QuickBiFinancialHistory: () => import('@/views/quick-bi-system/financial/history/index'), // 财务历史垫付
		QuickBiFinancialCheckComputation: () =>
			import('@/views/quick-bi-system/financial/check_computation/index'), // 财务核算报表
		QuickBiFinancialBadDebtStatistic: () =>
			import('@/views/quick-bi-system/financial/bad_debt_statistic/index'), // 渠道坏账统计报表
		QuickBiFinancialPayment: () => import('@/views/quick-bi-system/financial/payment/index'), // 财务付款监控报表

		// 风控中心大盘
		QuickBiServiceCenterRisk: () => import('@/views/quick-bi-system/service_center/risk/index'), // 风控中心大盘
		QuickBiServiceDriverTurned: () =>
			import('@/views/quick-bi-system/service_center/driver_turned/index'), //  司机自首
		QuickBiServiceCenterInducedCancel: () =>
			import('@/views/quick-bi-system/service_center/induced_cancel/index'), // 诱导取消
		QuickBiServiceCenterAccountability: () =>
			import('@/views/quick-bi-system/service_center/accountability/index'), // 自动判责
		QuickBiServiceCenterDetours: () =>
			import('@/views/quick-bi-system/service_center/detours/index'), // 绕路风控
		QuickBiServiceCenterSmart: () => import('@/views/quick-bi-system/service_center/smart/index'), // 智能客服数据看板
		QuickBiServiceCenterCpo: () => import('@/views/quick-bi-system/service_center/cpo/index'), // 客服语音cpo统计
		QuickBiServiceCenterRealTimeData: () =>
			import('@/views/quick-bi-system/service_center/real_time_data/index'), // 即时客诉数据
		QuickBiServiceCenterRealTimeDaily: () =>
			import('@/views/quick-bi-system/service_center/real_time_daily/index'), // 即时客诉日报
		QuickBiServiceCenterWorkOrderStatistics: () =>
			import('@/views/quick-bi-system/service_center/statistics/index'), // 工单统计看板
		QuickBiServiceCenterScene: () => import('@/views/quick-bi-system/service_center/scene/index'), // 工单业务现场看板

		// 终端业务
		QuickBiTerminalYZIndicators: () =>
			import('@/views/quick-bi-system/terminal/y_z_indicators/index'), // 阳仔关键指标
		QuickBiTerminalYZHour: () => import('@/views/quick-bi-system/terminal/y_z_hour/index'), //  阳仔小时看板
		QuickBiTerminalYZIncreasingly: () =>
			import('@/views/quick-bi-system/terminal/y_z_increasingly/index'), // 阳仔日趋看板
		QuickBiTerminalDriverBehavior: () =>
			import('@/views/quick-bi-system/terminal/driver_behavior/index'), // 司机端行为看板
		QuickBiTerminalDriverDept: () => import('@/views/quick-bi-system/terminal/driver_dept/index'), // 司机催款报表
		QuickBiTerminalDriverEvaluation: () =>
			import('@/views/quick-bi-system/terminal/driver_evaluation/index'), // 司机评价报表
		QuickBiTerminalOCR: () => import('@/views/quick-bi-system/terminal/ocr/index'), // OCR统计看板
		QuickBiTerminalNavigationInstructions: () =>
			import('@/views/quick-bi-system/terminal/navigation_instructions/index'), // 导航指标看板

		// AI大盘
		QuickBiAIBusinessData: () => import('@/views/quick-bi-system/ai/business_data/index'), // 业务数据看板

		// 运力资产
		QuickBiCapacityAssetJoinFunnel: () =>
			import('@/views/quick-bi-system/capacity_assets/join_funnel/index'), // 运力加盟漏斗
		QuickBiCapacityAssetsActiveFunnel: () =>
			import('@/views/quick-bi-system/capacity_assets/active_funnel'), // 活跃运力漏斗
		QuickBiCapacityAssetWeekFunnel: () =>
			import('@/views/quick-bi-system/capacity_assets/week_funnel/index'), // 运力周漏斗
		QuickBiCapacityAssetCompliance: () =>
			import('@/views/quick-bi-system/capacity_assets/compliance/index'), // 合规运力概况
		QuickBiCapacityAssetIM: () => import('@/views/quick-bi-system/capacity_assets/i_m/index'), // IM群聊统计看板
		QuickBiCapacityAssetTransferAudit: () =>
			import('@/views/quick-bi-system/capacity_assets/transfer_audit/index.vue'), // 换车审核
		QuickBiCapacityAssetCheckTrue: () =>
			import('@/views/quick-bi-system/capacity_assets/check_true/index'), // 三方验真
		QuickBiCapacityAssetRecruitAudit: () =>
			import('@/views/quick-bi-system/capacity_assets/recruit_audit/index'), // 招募审核
		QuickBiCapacityAssetEpidemicPrevention: () =>
			import('@/views/quick-bi-system/capacity_assets/epidemic_prevention/index'), // 防疫承诺书
		QuickBiCapacityAssetEpidemicPreventionCode: () =>
			import('@/views/quick-bi-system/capacity_assets/epidemic_prevention_code/index'), // 防疫乘客扫码
		QuickBiCapacityAssetDriverOrder: () =>
			import('@/views/quick-bi-system/capacity_assets/driver_order/index'), // 司机把脉_接单
		// 自营业务
		QuickBiProprietaryTradTodaySession: () =>
			import('@/views/quick-bi-system/proprietary_trad/today_session/index'), // 今日时段看板
		QuickBiProprietaryTradIncreasingly: () =>
			import('@/views/quick-bi-system/proprietary_trad/increasingly/index'), // 日趋看板
		QuickBiProprietaryTradUserLabel: () =>
			import('@/views/quick-bi-system/proprietary_trad/user_label/index') // 用户标签
	}
} else {
	quickBiRouter = {}
}
export const mapRouter = {
	...basisRouter,
	...quickBiRouter,
	...governRouter,
	...pricingRouter,
	...payCenterRouter,
	...operationRouter,
	...toolsRouter,
	...workOrderRouter
}
const createRouter = () =>
	new Router({
		// mode: 'history', // require service support
		scrollBehavior: () => ({ y: 0 }),
		routes: [
			...constantRoutes,
			...governRouters,
			...pricingRouters,
			...payCenterRouters,
			...externalSysRouters,
			...operationRouters,
			...workOrderRouters,
			...toolsRoutes
		]
	})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
